var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blockquote',{staticClass:"quote"},[(_vm.size === 'med')?_c('h4',{domProps:{"innerHTML":_vm._s(_vm.quote)}}):_c('h5',{domProps:{"innerHTML":_vm._s(_vm.quote)}})])}
var staticRenderFns = []

export { render, staticRenderFns }